<script setup>
// Props
const props = defineProps({
    download: {
        type: Object,
        default: () => ({}),
        validator(rawValue) {
            const validations = {
                downloadLinkUrl: rawValue => rawValue?.downloadLinkUrl === undefined || typeof rawValue?.downloadLinkUrl === 'string',
                downloadLinkText: rawValue => rawValue?.downloadLinkText === undefined || typeof rawValue?.downloadLinkText === 'string',
                downloadFileUrl: rawValue => rawValue?.downloadFileUrl === undefined || typeof rawValue?.downloadFileUrl === 'string',
                downloadFileText: rawValue => rawValue?.downloadFileText === undefined || typeof rawValue?.downloadFileText === 'string'
            }

            return Object.values(validations).every(validation => validation(rawValue))
        }
    }
})

const downloadButtonConfig = computed(() => {
    return {
        buttonType: 'primary',
        type: 'external',
        link: props.download?.downloadLinkUrl,
        active: true
    }
})

const downloadFileButtonConfig = computed(() => {
    return {
        buttonType: 'primary',
        type: 'file',
        link: props.download?.downloadFileUrl,
        active: true
    }
})
</script>

<template>
    <div class="content-detail-download-bar">
        <BaseButton v-if="download?.downloadLinkUrl && download?.downloadLinkText" :base-button-config="downloadButtonConfig">
            {{ download?.downloadLinkText }}
        </BaseButton>

        <BaseButton v-if="download?.downloadFileUrl && download?.downloadFileText" :base-button-config="downloadFileButtonConfig">
            {{ download?.downloadFileText }}
        </BaseButton>
    </div>
</template>

<style lang="scss">
.content-detail-download-bar {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 30px auto 10px;
    flex-flow: row wrap;

    > a {
        margin: 0 20px 20px;
    }
}
</style>
